import { getApi } from '@frontend/api-client';
import { fetchBaseQuery } from '@reduxjs/toolkit/query';

type GetApiSliceParams =
  | {
      apiUrl: string;
      appVersion: string;
      platform: 'mobile';
    }
  | {
      apiUrl: string;
      appVersion?: never;
      platform: 'web';
    };

export const getBaseApiSlice = <TRootState extends { auth: { token: string } }>({
  apiUrl,
  appVersion,
  platform,
}: GetApiSliceParams) =>
  getApi({
    baseQuery: fetchBaseQuery({
      baseUrl: apiUrl,
      prepareHeaders: (headers, { getState }) => {
        const {
          auth: { token },
        } = getState() as TRootState;

        if (token) {
          headers.set('Authorization', `Bearer ${token}`);
        }

        if (platform === 'mobile' && appVersion) {
          headers.set('Duckbill-Mobile-App-Version', appVersion);
        }

        return headers;
      },
    }),
  });
